import React, { useEffect, useRef } from 'react';
import './Audio.css';
import log from '../../utility/log';

/**
 *
 * @param element {HTMLElement}
 */
async function setMathJaxTypeset(element) {
  if (!element) {
    return log(
      'typesetting MathJax without element is not allowed for performance reasons',
    );
  }
  await window.MathJax?.typesetPromise?.([element]);
}

// Cast from string to html so we can inspect the attributes
const extractAudioSrc = (htmlText) => {
  // fast path, light but not strict match for 'data-type="audioplayer" (to avoid misquoting/bad xml/etc)
  if (htmlText && !htmlText.includes('audioplayer')) {
    return {
      spanAsHtml: '',
      isAudioFile: false,
    };
  }
  const tmpl = document.createElement('div');
  tmpl.innerHTML = htmlText;
  const spanAsHtml = tmpl.querySelector('span[data-type="audioplayer"]');
  const isAudioFile =
    spanAsHtml && spanAsHtml.getAttribute('data-type') === 'audioplayer';
  return {
    spanAsHtml,
    isAudioFile,
  };
};

const LearnosityText = ({ text, ...props }) => {
  const textRef = useRef();
  const { spanAsHtml, isAudioFile } = extractAudioSrc(text);

  useEffect(() => {
    setMathJaxTypeset(textRef.current);
  }, [text]);

  const divProps = {
    ...(!isAudioFile && { dangerouslySetInnerHTML: { __html: text } }),
    ...(isAudioFile && {
      children: (
        <audio src={spanAsHtml.getAttribute('data-src')} controls>
          <track kind="captions" src="" srcLang="en" label="English" default />
        </audio>
      ),
    }),
  };

  return <div ref={textRef} {...divProps} {...props} />;
};

export default LearnosityText;
